export default __webpack_public_path__ + "assets/images/dd78c16749d9ee5f5aa20db56c7d91cf.png";